import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import XIcon from 'svg/XIcon';

type Props = {
  onClick: () => void;
  className?: string;
  color?: string;
  size?: number;
  'aria-label'?: string;
  'data-testid'?: string;
};

export default function CloseButton({
  onClick,
  className,
  color,
  size = 12,
  'aria-label': ariaLabel = 'Close',
  'data-testid': dataTestId,
}: Props) {
  return (
    <StyledCloseButton
      type='button'
      aria-label={ariaLabel}
      onClick={onClick}
      className={className}
      data-testid={dataTestId}
      $color={color}>
      <XIcon width={size} height={size} />
    </StyledCloseButton>
  );
}

const StyledCloseButton = styled.button<{ $color?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  color: ${({ $color }) => $color ?? colors.black75};
`;
